/**
 * Store admin — buyers route (Commerce, M3).
 *
 * @see apps/web/src/features/store/buyers/buyers-list-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { BuyersListPage } from "../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/buyers/")({
  component: BuyersListPage,
});
